import "./App.css";
import { Routes, Route } from "react-router-dom";
// import LoginPage from "./pages/login";
import Dashboard2 from "./pages/dashboard2";
import DashboardPage from "./pages/dashboard";
import ChatPage from "./pages/chat/index";

function App() {
  return (
    <Routes>
      <Route path="/" exact element={<DashboardPage />} />
      <Route path="/dashboard" exact element={<Dashboard2 />} />
      <Route path="/app" exact element={<ChatPage />} />
      {/*<Route path="/login" exact element={<LoginPage />} />*/}
    </Routes>
  );
}

export default App;
